import { HttpContextToken } from '@angular/common/http';

export const SkipLoaderToken = new HttpContextToken<boolean>(() => true);
export const SuppressErrorNotification = new HttpContextToken<boolean>(
  () => true
);
